/**
 * 퀘스트 테이블. 수치는 `quests.json`.
 */

import seed from './quests.json';
import { emitDataReloadSoon, replaceRecord, requireRecord } from './catalog';

export type QuestKind = 'hunt' | 'collect';

export interface QuestItemReward {
  itemId: string;
  count: number;
}

export interface QuestDef {
  id: string;
  name: string;
  npcId: string;
  requires: readonly string[];
  kind: QuestKind;
  monsterId?: string;
  itemId?: string;
  count: number;
  exp: number;
  meso: number;
  items: readonly QuestItemReward[];
  offer: string;
  active: string;
  ready: string;
  done: string;
}

export const QUESTS: Record<string, QuestDef> = structuredClone(seed.QUESTS) as Record<string, QuestDef>;

export function getQuest(id: string): QuestDef | undefined {
  return QUESTS[id];
}

export function applyQuests(raw: unknown): void {
  const data = requireRecord(raw, 'quests.json');
  replaceRecord(QUESTS, structuredClone(requireRecord(data.QUESTS, 'QUESTS')) as Record<string, QuestDef>);
}

if (import.meta.hot) {
  import.meta.hot.accept('./quests.json', (mod) => {
    if (!mod?.default) return;
    applyQuests(mod.default);
    emitDataReloadSoon();
  });
}
